<template>
  <div class="exam-schedule-management">
    <div class="header">
      <h2>备考时间管理</h2>
      <el-button type="primary" icon="el-icon-plus" @click="handleCreate">新增配置</el-button>
    </div>

    <div class="filter-bar">
      <el-select v-model="filters.courseTypeCode" clearable filterable placeholder="课程类型" style="width: 180px" @change="handleFilterCourseTypeChange">
        <el-option v-for="item in courseTypeOptions" :key="item.code" :label="item.label" :value="item.code" />
      </el-select>
      <el-select v-model="filters.subjectCode" clearable filterable placeholder="等级/科目" style="width: 180px; margin-left: 10px" @change="loadList">
        <el-option v-for="item in filterSubjectOptions" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
      <el-select v-model="filters.targetYear" clearable placeholder="年份" style="width: 150px; margin-left: 10px" @change="loadList">
        <el-option v-for="y in filterYearOptions" :key="y" :label="y + '年'" :value="y" />
      </el-select>
      <el-input v-model="filters.sessionCode" :placeholder="filters.courseTypeCode === 'GESP' ? '场次，如 2026-03' : '场次编码'" clearable style="width: 180px; margin-left: 10px" @keyup.enter.native="loadList" />
      <el-select v-model="filters.status" clearable placeholder="状态" style="width: 120px; margin-left: 10px" @change="loadList">
        <el-option label="启用" :value="1" />
        <el-option label="禁用" :value="0" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" style="margin-left: 10px" @click="loadList">查询</el-button>
      <el-button icon="el-icon-refresh" @click="resetFilters">重置</el-button>
    </div>

    <el-table :data="list" v-loading="loading" border style="width: 100%; margin-top: 20px">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="courseTypeCode" label="课程类型" width="120" />
      <el-table-column prop="subjectCode" label="等级/科目" min-width="140" />
      <el-table-column prop="targetYear" label="年份" width="100" />
      <el-table-column prop="sessionCode" label="场次" min-width="120">
        <template slot-scope="scope">{{ scope.row.sessionCode || '-' }}</template>
      </el-table-column>
      <el-table-column prop="examDate" label="考试时间" min-width="180">
        <template slot-scope="scope">{{ formatTime(scope.row.examDate) }}</template>
      </el-table-column>
      <el-table-column prop="remarks" label="备注" min-width="180" show-overflow-tooltip />
      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">{{ scope.row.status === 1 ? '启用' : '禁用' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 20px; text-align: right"
    />

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="680px" @close="handleDialogClose">
      <el-form ref="configForm" :model="formData" :rules="formRules" label-width="110px">
        <el-form-item label="课程类型" prop="courseTypeCode">
          <el-select v-model="formData.courseTypeCode" filterable placeholder="请选择课程类型" style="width: 100%" @change="handleFormCourseTypeChange">
            <el-option v-for="item in courseTypeOptions" :key="item.code" :label="item.label" :value="item.code" />
          </el-select>
        </el-form-item>
        <el-form-item label="等级/科目" prop="subjectCode">
          <el-select v-model="formData.subjectCode" filterable placeholder="请选择等级/科目" style="width: 100%">
            <el-option v-for="item in formSubjectOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="年份" prop="targetYear">
          <el-input-number v-model="formData.targetYear" :min="2024" :max="2100" controls-position="right" style="width: 100%" />
        </el-form-item>
        <el-form-item label="场次编码">
          <el-select v-if="isGespForm" v-model="formData.sessionCode" filterable allow-create default-first-option placeholder="请选择或输入场次，例如 2026-03" style="width: 100%">
            <el-option v-for="item in monthSessionOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
          <el-input v-else v-model="formData.sessionCode" placeholder="AMC 可留空，其他考试可按需填写场次编码" />
        </el-form-item>
        <el-form-item label="考试时间" prop="examDate">
          <el-date-picker v-model="formData.examDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :default-value="examDatePickerDefault" placeholder="选择考试时间" style="width: 100%" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="formData.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="formData.remarks" type="textarea" :rows="3" placeholder="可填写该场考试说明" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getExamScheduleConfigPage,
  createExamScheduleConfig,
  updateExamScheduleConfig,
  deleteExamScheduleConfig
} from '@/api/examScheduleConfig'
import { getCourseCategories } from '@/api/course'
import { fetchRepoByCourseId } from '@/api/repo'

export default {
  name: 'ExamScheduleManagement',
  data() {
    return {
      loading: false,
      list: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      categoryList: [],
      repoMap: {},
      dialogVisible: false,
      dialogTitle: '新增配置',
      submitting: false,
      filters: {
        courseTypeCode: '',
        subjectCode: '',
        targetYear: null,
        sessionCode: '',
        status: null
      },
      formData: this.getDefaultForm(),
      formRules: {
        courseTypeCode: [{ required: true, message: '请输入课程类型', trigger: 'blur' }],
        subjectCode: [{ required: true, message: '请输入等级/科目', trigger: 'blur' }],
        targetYear: [{ required: true, message: '请输入年份', trigger: 'change' }],
        examDate: [{ required: true, message: '请选择考试时间', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  computed: {
    courseTypeOptions() {
      return (Array.isArray(this.categoryList) ? this.categoryList : [])
        .filter(item => item && item.code)
        .map(item => ({
          code: String(item.code).trim().toUpperCase(),
          label: `${item.name || item.code} (${String(item.code).trim().toUpperCase()})`
        }))
    },
    filterSubjectOptions() {
      return this.getSubjectOptions(this.filters.courseTypeCode)
    },
    formSubjectOptions() {
      return this.getSubjectOptions(this.formData.courseTypeCode)
    },
    isGespForm() {
      return String(this.formData.courseTypeCode || '').trim().toUpperCase() === 'GESP'
    },
    monthSessionOptions() {
      const year = Number(this.formData.targetYear)
      if (!year) return []
      return Array.from({ length: 12 }).map((_, index) => {
        const month = String(index + 1).padStart(2, '0')
        return {
          value: `${year}-${month}`,
          label: `${year}年${month}月`
        }
      })
    },
    filterYearOptions() {
      const current = new Date().getFullYear()
      const years = []
      for (let y = current - 1; y <= current + 5; y++) {
        years.push(y)
      }
      return years
    },
    examDatePickerDefault() {
      const year = Number(this.formData.targetYear) || new Date().getFullYear()
      const sc = String(this.formData.sessionCode || '').trim()
      const match = sc.match(/^(\d{4})-(\d{1,2})$/)
      if (match) {
        return new Date(Number(match[1]), Number(match[2]) - 1, 1)
      }
      return new Date(year, 0, 1)
    }
  },
  created() {
    this.initPage()
  },
  methods: {
    async initPage() {
      await Promise.all([this.loadCourseAndRepoOptions(), this.loadList()])
    },
    getDefaultForm() {
      return {
        id: null,
        courseTypeCode: '',
        subjectCode: '',
        targetYear: new Date().getFullYear(),
        sessionCode: '',
        examDate: '',
        status: 1,
        remarks: ''
      }
    },
    async loadCourseAndRepoOptions() {
      try {
        const categoryRes = await getCourseCategories().catch(() => null)
        const categories = (categoryRes && (categoryRes.data !== undefined ? categoryRes.data : categoryRes)) || []
        this.categoryList = Array.isArray(categories) ? categories : []
      } catch (e) {
        this.categoryList = []
      }
    },
    async loadReposByCategoryId(categoryId) {
      if (!categoryId) return []
      const key = String(categoryId)
      if (this.repoMap[key]) return this.repoMap[key]
      try {
        const res = await fetchRepoByCourseId(categoryId)
        const data = (res && (res.data !== undefined ? res.data : res)) || []
        const list = Array.isArray(data) ? data : []
        this.$set(this.repoMap, key, list)
        return list
      } catch (e) {
        return []
      }
    },
    getCategoryByCode(code) {
      const categoryCode = String(code || '').trim().toUpperCase()
      if (!categoryCode) return null
      return (Array.isArray(this.categoryList) ? this.categoryList : [])
        .find(item => String(item?.code || '').trim().toUpperCase() === categoryCode) || null
    },
    getSubjectOptions(courseTypeCode) {
      const cat = this.getCategoryByCode(courseTypeCode)
      if (!cat) return []
      const list = this.repoMap[String(cat.id)] || []
      return list
        .map(item => ({
          value: String(item.title || '').trim().toUpperCase(),
          label: String(item.title || '').trim()
        }))
        .filter(item => item.value)
    },
    async loadList() {
      this.loading = true
      try {
        const res = await getExamScheduleConfigPage({
          current: this.currentPage,
          size: this.pageSize,
          courseTypeCode: this.filters.courseTypeCode || undefined,
          subjectCode: this.filters.subjectCode || undefined,
          targetYear: this.filters.targetYear || undefined,
          sessionCode: this.filters.sessionCode || undefined,
          status: this.filters.status
        })
        console.log('[ExamSchedule] loadList raw res:', JSON.stringify(res).substring(0, 500))
        let page = res || {}
        // 兼容 axios 拦截器可能返回 res.data 或 res.data.data
        if (page.code !== undefined && page.data !== undefined) {
          page = page.data
        }
        if (page && !Array.isArray(page.records) && page.data && typeof page.data === 'object') {
          page = page.data
        }
        console.log('[ExamSchedule] parsed page:', JSON.stringify(page).substring(0, 500))
        this.list = Array.isArray(page.records) ? page.records : []
        this.total = Number(page.total) || 0
      } catch (e) {
        console.error(e)
        this.$message.error('加载备考时间配置失败')
      } finally {
        this.loading = false
      }
    },
    resetFilters() {
      this.filters = { courseTypeCode: '', subjectCode: '', targetYear: null, sessionCode: '', status: null }
      this.currentPage = 1
      this.loadList()
    },
    async handleFilterCourseTypeChange() {
      this.filters.subjectCode = ''
      const cat = this.getCategoryByCode(this.filters.courseTypeCode)
      if (cat) await this.loadReposByCategoryId(cat.id)
      this.loadList()
    },
    handleCreate() {
      this.dialogTitle = '新增配置'
      this.formData = this.getDefaultForm()
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.configForm) this.$refs.configForm.clearValidate()
      })
    },
    async handleFormCourseTypeChange() {
      this.formData.subjectCode = ''
      if (String(this.formData.courseTypeCode || '').trim().toUpperCase() !== 'GESP') {
        this.formData.sessionCode = ''
      }
      const cat = this.getCategoryByCode(this.formData.courseTypeCode)
      if (cat) await this.loadReposByCategoryId(cat.id)
    },
    async handleEdit(row) {
      this.dialogTitle = '编辑配置'
      this.formData = { ...this.getDefaultForm(), ...row }
      const cat = this.getCategoryByCode(this.formData.courseTypeCode)
      if (cat) await this.loadReposByCategoryId(cat.id)
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.configForm) this.$refs.configForm.clearValidate()
      })
    },
    handleDialogClose() {
      this.formData = this.getDefaultForm()
    },
    handleSubmit() {
      this.$refs.configForm.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          const payload = {
            ...this.formData,
            courseTypeCode: String(this.formData.courseTypeCode || '').trim().toUpperCase(),
            subjectCode: String(this.formData.subjectCode || '').trim().toUpperCase(),
            sessionCode: this.formData.sessionCode ? String(this.formData.sessionCode).trim().toUpperCase() : null
          }
          if (payload.id) {
            await updateExamScheduleConfig(payload.id, payload)
          } else {
            await createExamScheduleConfig(payload)
          }
          this.$message.success('保存成功')
          this.dialogVisible = false
          this.loadList()
        } catch (e) {
          console.error(e)
          this.$message.error('保存失败')
        } finally {
          this.submitting = false
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确认删除该考试时间配置吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await deleteExamScheduleConfig(row.id)
        this.$message.success('删除成功')
        this.loadList()
      }).catch(() => {})
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.loadList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadList()
    },
    formatTime(value) {
      if (!value) return '-'
      return new Date(value).toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped>
.exam-schedule-management {
  padding: 20px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.filter-bar {
  margin-top: 20px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0;
}
</style>
